import React, { useEffect } from 'react';
import { Form, Input, Button, Row, Col, Checkbox } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { resetApiStatus } from 'redux/reducers/globals/globalActions';
import { postApi } from 'redux/sagas/postApiDataSaga';

const MASTER_OPTIONS = [
	{ label: 'Customers', value: 'customers' },
	{ label: 'Items', value: 'items' },
	{ label: 'Categories', value: 'categories' },
	{ label: 'Item Rates', value: 'rates' },
	{ label: 'Wash Remarks', value: 'remarks' },
];

const CloneOrganization = ({ sourceOrg, refreshList, closeModal }) => {
	const globalRedux = useSelector((state) => state.globalRedux);
	const dispatch = useDispatch();
	const [cloneFormInstance] = Form.useForm();

	const FormCol = {
		labelCol: { span: 24 },
		wrapperCol: { span: 24 },
	};

	const onSubmit = (values) => {
		dispatch(
			postApi(
				{
					srcOrgId: sourceOrg.id || sourceOrg._id,
					orgName: values.orgName,
					gstin: values.gstin,
					masters: values.masters,
				},
				'CLONE_ORGANIZATION'
			)
		);
	};

	useEffect(() => {
		if (globalRedux.apiStatus.CLONE_ORGANIZATION === 'SUCCESS') {
			cloneFormInstance.resetFields();
			refreshList();
			dispatch(resetApiStatus('CLONE_ORGANIZATION'));
		}
	}, [globalRedux.apiStatus.CLONE_ORGANIZATION, dispatch, cloneFormInstance, refreshList]);

	return (
		<Form
			style={{ padding: '0' }}
			className="custom-form"
			requiredMark={false}
			colon={false}
			layout="vertical"
			labelAlign="left"
			form={cloneFormInstance}
			onFinish={onSubmit}
			initialValues={{ masters: ['customers', 'items'] }}
			{...FormCol}>
			<p style={{ fontSize: 13, color: '#666', marginBottom: 16 }}>
				Cloning from: <strong>{sourceOrg?.orgName}</strong>
			</p>

			<Form.Item
				label="New Organization Name"
				name="orgName"
				rules={[{ required: true, message: 'This field is required!' }]}>
				<Input placeholder="Enter new organization name" />
			</Form.Item>

			<Form.Item
				label="New GSTIN"
				name="gstin"
				rules={[{ required: true, message: 'This field is required!' }]}>
				<Input placeholder="Enter new GSTIN" />
			</Form.Item>

			<Form.Item
				label="Select masters to clone"
				name="masters"
				rules={[{ required: true, message: 'Select at least one master to clone' }]}>
				<Checkbox.Group options={MASTER_OPTIONS} style={{ display: 'flex', flexDirection: 'column', gap: 8 }} />
			</Form.Item>

			<p style={{ fontSize: 12, color: '#999', marginBottom: 16 }}>
				Note: Item Rates require both Items and Categories to be selected.
			</p>

			<Form.Item wrapperCol={{ offset: 0 }}>
				<Row gutter={[10, 10]}>
					<Col span={12}>
						<Button
							loading={globalRedux.apiStatus.CLONE_ORGANIZATION === 'PENDING'}
							disabled={globalRedux.apiStatus.CLONE_ORGANIZATION === 'PENDING'}
							type="primary"
							style={{ width: '100%' }}
							htmlType="submit">
							Clone Organization
						</Button>
					</Col>
					<Col span={12}>
						<Button
							style={{ width: '100%' }}
							onClick={() => {
								closeModal();
								cloneFormInstance.resetFields();
							}}
							danger>
							Cancel
						</Button>
					</Col>
				</Row>
			</Form.Item>
		</Form>
	);
};

export default CloneOrganization;
